import type React from 'react';
import type { CodingTier, FitVerdict } from './types.js';

export function VerdictPill({ verdict }: { verdict: FitVerdict }) {
  const label: Record<FitVerdict, string> = {
    great: 'Great fit',
    good: 'Good fit',
    usable: 'Usable',
    'chat-only': 'Chat only',
    technical: 'Technically runs',
    no: 'Not recommended',
  };
  return <span className={`verdict-pill verdict-${verdict}`}>{label[verdict]}</span>;
}

export function TierBadge({ tier }: { tier: CodingTier }) {
  return <span className={`tier-badge tier-${tier.toLowerCase()}`}>{tier}-tier</span>;
}

export function StatRow({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="lab-stat-row">
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

export function Bar({
  value,
  max,
  tone = 'cyan',
}: { value: number; max: number; tone?: 'cyan' | 'mint' | 'gold' | 'coral' }) {
  const pct = Math.max(0, Math.min(100, (value / Math.max(1, max)) * 100));
  return (
    <div className="lab-bar">
      <div className={`lab-bar-fill lab-bar-${tone}`} style={{ width: `${pct}%` }} />
    </div>
  );
}

export function ConfidenceDot({ confidence }: { confidence: 'low' | 'medium' | 'high' }) {
  return (
    <span className={`confidence-dot confidence-${confidence}`} title={`${confidence} confidence estimate`} />
  );
}
